__turbopack_context__.v({
  "address": "Address-module-scss-module__Npd08a__address",
  "description": "Address-module-scss-module__Npd08a__description",
  "name": "Address-module-scss-module__Npd08a__name",
});
